import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

const propTypes = {
  investmentApproach: PropTypes.string
}

const defaultProps = {
  investmentApproach: ''
}

/**
 * Investment Approach Component
 * @param props
 */
function InvestmentApproach ({ investmentApproach }) {
  if (!investmentApproach || !investmentApproach.length) {
    return null
  }

  return (
    <Grid container spacing={2} className='tearsheet_section'>
      <Grid item xs={12} className='tearsheet_section-title'>Investment Approach</Grid>
      <Grid item xs={12} className='tearsheet_section-content tearsheet_section-content-editor'>
        {investmentApproach}
      </Grid>
    </Grid>
  )
}

InvestmentApproach.propTypes = propTypes
InvestmentApproach.defaultProps = defaultProps

export default memo(InvestmentApproach)
